import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Project Members tab table row placeholder: avatar + name / skills / email
 * / phone / role columns (all 5 columns of the Members table).
 */
export const MemberRowSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'member-row-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingVertical='s'
      borderBottomWidth={1}
      borderBottomColor='grey02'>
      <Skeleton
        variant='circle'
        width={28}
        height={28}
        style={{ marginRight: theme.spacing.xs }}
      />
      <Box flex={2} marginRight='s'>
        <Skeleton variant='text' width='60%' />
      </Box>
      <Box flex={2} marginRight='s'>
        <Skeleton variant='text' width='70%' />
      </Box>
      <Box flex={2} marginRight='s'>
        <Skeleton variant='text' width='80%' />
      </Box>
      <Box flex={2} marginRight='s'>
        <Skeleton variant='text' width='50%' />
      </Box>
      <Box flex={1}>
        <Skeleton variant='text' width='60%' />
      </Box>
    </Box>
  );
};
